import { Box } from '@mui/material';
import { notUndefiend, valueAsString } from 'helpers/conversions';
import React from 'react';
import { ICardProps, StatsData } from './Card';
import { Spinner, SpinnerContainer } from './Styles';
import { ReactComponent as ArrowUp } from '../../assets/icons/ArrowUp.svg';
import { styles } from './TotatImpressionCardMobile.styles';
const TotalImpressionCardMobile = (props: ICardProps) => {
  const {
    value,
    units,
    description,
    icons,
    stats,
    statsDescription,
    isPercentage,
    addedData,
  } = props;
  const isNegative = React.useMemo(() => {
    if (!notUndefiend([stats])) {
      return false;
    }
    if (stats! < 0) {
      return true;
    }
    if (description === 'Average Availability' && value !== undefined && value >= 0.999) {
      return false;
    }
    return false;
  }, [description, stats, value]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box">
      {notUndefiend([value]) ? (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            height="70px"
            boxSizing="border-box">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              width={addedData ? '60%' : '100%'}
              height="70px"
              boxSizing="border-box">
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={styles.contentRow}>
                {isNegative ? icons.negative : icons.positive}{' '}
                <Box sx={styles.value} data-testid="total-impression-value">
                  {valueAsString(value, isPercentage)}
                </Box>
                <Box sx={styles.units}>{units}</Box>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={styles.descriptionRow}
                data-testid="total-impression-description">
                {description}
              </Box>
            </Box>
            {addedData && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                height="100%"
                boxSizing="border-box"
                sx={styles.rightColumn}>
                <Box display="flex" flexDirection="column" boxSizing="border-box">
                  <Box display="flex" justifyContent="space-between" alignItems="baseline">
                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      sx={styles.valueAndUnitWrapper}
                      data-id="ValueAndUnitWrapper">
                      <Box sx={styles.rightColumnRowValueSubRowItemValue} data-testid="added-value">
                        {addedData.upper.formatter
                          ? addedData.upper.formatter(addedData.upper.value)
                          : valueAsString(addedData.upper.value!)}
                      </Box>
                      <Box sx={styles.rightColumnRowValueSubRowItemUnits} data-testid="added-units">
                        {addedData.upper.unit}
                      </Box>
                    </Box>

                    <Box>
                      {addedData.upper.trend !== 0 && addedData.upper.trend !== undefined && (
                        <ArrowUp
                          width={14}
                          height={18}
                          style={{ transform: addedData.upper.trend < 0 ? 'rotate(180deg)' : '' }}
                        />
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={styles.rightColumnRowDescriptionSubRow}
                    data-testid="added-stats-description">
                    {addedData.upper.description}
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
          <Box
            display="flex"
            alignItems="flex-end"
            width="100%"
            height="30px"
            boxSizing="border-box"
            sx={styles.bottomRow}
            data-testid="total-impression-stats-description">
            {StatsData(stats!)} {statsDescription}
          </Box>
        </>
      ) : (
        <SpinnerContainer> {Spinner()}</SpinnerContainer>
      )}
    </Box>
  );
};
export default TotalImpressionCardMobile;
